export default "__VITE_ASSET__DnimruU3__"